import React from 'react';

type FieldMode = 'add' | 'edit' | 'view';

interface RejectReasonProperties {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  label: string;
  placeholder: string;
  mode?: FieldMode;
  disabled?: boolean;
}

/**
 * Reusable reject reason textarea
 * Supports add / edit / view modes
 */
function RejectReasonField({
  value,
  onChange,
  error,
  label,
  placeholder ,
  mode,
  disabled = false,
}: RejectReasonProperties) {
  const isViewMode = mode === 'view';
  const isDisabled = disabled || isViewMode;

  /**
   * handleChange
   * @param event 
   */
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(event.target.value);
  };

  /**
   * handleBlur
   * @param event 
   */
  const handleBlur = (event: React.FocusEvent<HTMLTextAreaElement>) => {
    onChange(event.target.value.trim());
  };

  const labelId = 'reject-reason-textarea';

  return (
    <div className="reject-reason-field">
      {label && (
        <label
          htmlFor={labelId}
          className={`reject-reason-field__label ${
            error ? 'reject-reason-field__label--error' : ''
          }`}
        >
          {label}
          {!isViewMode && <span className="required">*</span>}
        </label>
      )}

      <textarea
        id={labelId}
        className={`reject-reason-field__textarea ${
          error ? 'reject-reason-field__textarea--error' : ''
        } ${isViewMode ? 'view-mode' : ''}`}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        disabled={isDisabled}
        readOnly={isViewMode}
      />

      {error && <span className="reject-reason-field__error">{error}</span>}
    </div>
  );
}

RejectReasonField.defaultProps={
    error:null ,
  mode: null,
  disabled: null,
}

export default RejectReasonField;
